'use client';
import ContractPage from '@/pages/contract/page';
const Page = (props: any) => {
  return <ContractPage {...props} isPreview />;
};
export default Page;
